export const getSessionStorageItem = (projectId: string, key: string, defaultValue: string = ''): string => {
  try {
    const storedValue = sessionStorage.getItem(`project_${projectId}_${key}`);
    if (storedValue !== null) {
      sessionStorage.removeItem(`project_${projectId}_${key}`);
    }
    return storedValue !== null ? storedValue : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

export const setSessionStorageItem = (projectId: string, key: string, value: string): void => {
  try {
    if (value) {
      sessionStorage.setItem(`project_${projectId}_${key}`, value);
    }
  } catch (e) {
    // Silent fail on storage errors
  }
};

export const saveSearchState = (projectId: string, searchTerm: string, searchField: string): void => {
  if (searchTerm) {
    sessionStorage.setItem(`project_${projectId}_searchTerm`, searchTerm);
  }
  if (searchField && searchField !== 'all') {
    sessionStorage.setItem(`project_${projectId}_searchField`, searchField);
  }
}; 